import "./App.css";
import Weather from "./Weather";

export default function App() {
  return (
    <div className="App">
      <div className="container weather-app-wrapper">
        <div className="div-top"></div>
        <Weather defaultCity="Seattle" />
        <footer>
          This project was coded by Millanda Zhou and is{" "}
          <a
            href="https://github.com/millanda/react-weather-app"
            target="_blank"
            rel="noreferrer"
          >
            open-sourced on Github
          </a>{" "}
          and{" "}
          <a
            href="https://preeminent-gelato-7787cb.netlify.app/"
            target="_blank"
            rel="noreferrer"
          >
            hosted on Netlify
          </a>
          .
        </footer>
        <div className="div"></div>
      </div>
    </div>
  );
}
